<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gkidoi/tc-custom/9781646565030.jpg?1723404397469" alt="This image is the cover for the book Julio's Wolf, Werewolves of Manhattan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Julio's Wolf, Werewolves of Manhattan
      </h1>
      <p class="bookDescription body article font2">
        <p>Julio Reyes has had a hard life. Orphaned at fourteen, he ran away from a group home to avoid rape but wound up being an independent prostitute in NYC. He has a life plan -- go to school, become a stylist and open his own salon.<br/><br/>Etienne Daurensbourg is 139 years old and fears he’ll never find his Mate until his friend Alexei introduces him to Julio. Julio is Etienne’s Mate, but before he has a chance to court Julio -- who is a human high beta and therefore stubborn and independent -- Julio gets knifed and is forced to let Etienne provide him with a home and help to recover.<br/><br/>Pack problems arise that may force Etienne into the pit. Will Julio be able to love Etienne despite the fact he is a loup garou?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.C. Katt
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d8da379